import fetch from '@/api'

// 船公司放箱-获取基础资料（包含获取放箱类型，作业方式，作业单位等用于前端下拉列表框展示）
export function getBaseData(data) {
    return fetch({
        method: 'post',
        url: `/combo/get_base_data`,
        data
    })
}
// 获取货名下拉列表框展示
export function getGoodsList() {
    return fetch({
        method: 'get',
        url: `/combo/get_goods_list`
    })
}
// 
export function downloadModel() {
    return fetch({
        method: 'get',
        url: `/外进箱导入模版.xlsx`
    })
}
// 
export function importApplyExcel(applyType,attachmentId) {
    return fetch({
        method: 'POST',
        url: `/ship_excel/import_apply/${applyType}/${attachmentId}`
    })
}
// 船公司（重 空  外进统计）
export function getShipStatistics() {
    return fetch({
        method: 'get',
        url: `/shipfirstpage/apply_statistics`
    })
}
// 船公司（大图统计）
export function getBigTaskStatistics(params) {
    return fetch({
        method: 'get',
        url: `/shipfirstpage/get_task_statistics`,
        params
    })
}
//检查箱列表是否存在未完成的放箱计划
export function checkExistsApply(data) {
    return fetch({
        method: 'post',
        url: `/shipapply/check_exists_apply`,
        data
    })
}
// 船公司（待对账费用）
export function getShipAccountingStatistics() {
    return fetch({
        method: 'get',
        url: `/shipfirstpage/accounting_statistics`,
    })
}
// 船公司（对账记录查询）
export function getShipVerifyfeeRecord(params) {
    return fetch({
        method: 'get',
        url: `/queryshipfee/query_verifyfee_record`,
        params
    })
}

// 船公司（费用统计）
export function getShipFeeStatistics(params) {
    return fetch({
        method: 'get',
        url: `/shipfirstpage/fee_statistics`,
        params
    })
}
// 船公司（拖车公司排名统计）
export function getShipTaskStatistics(params) {
    return fetch({
        method: 'get',
        url: `/shipfirstpage/task_statistics`,
        params,
    })
}
// 船公司放箱-查询在场箱分页列表
export function getInportContainer(params) {
    return fetch({
        method: 'get',
        url: `/shipapply/query_inport_container_page`,
        params,
    })
}
// 查询查验熏蒸在场箱分页列表
export function getContainerSpecial(params) {
    return fetch({
        method: 'get',
        url: `/shipapply/query_container_special_page`,
        params,
    })
}
// 船公司放箱-查询在场箱列表
export function getInportContainerList(params) {
    return fetch({
        method: 'get',
        url: `/shipapply/query_inport_container`,
        params,
    })
}
// 船公司放箱-查看分配轨迹
export function getApplyDispatchRecord(applyDetailId) {
    return fetch({
        method: 'get',
        url: `/shipapply/get_apply_dispatch_record/${applyDetailId}`
    })
}
// 船公司放箱-预结算
export function preSettle(data) {
    return fetch({
        method: 'post',
        url: `/shipapply/pre_settle`,
        data
    })
}
// 船公司放箱-放箱（包含放重箱，放空箱，放外进箱）
export function createApply(data) {
    return fetch({
        method: 'post',
        url: `/shipapply/create_apply`,
        data
    })
}
// 船公司放箱-查询指定状态放箱列表（包含空、重、外进箱的待接收，被拒绝，已计划未完成，（空、重）已提箱未返港等相关放箱列表）
export function getApplydetail(params) {
    return fetch({
        method: 'get',
        url: `/shipapply/query_applydetail`,
        params,
    })
}
// 船公司放箱-查询指定状态放箱分页列表（包含空、重、外进箱的待接收，被拒绝，已计划未完成，（空、重）已提箱未返港等相关放箱列表）
export function getApplydetailPage(params) {
    return fetch({
        method: 'get',
        url: `/shipapply/query_applydetail_page`,
        params,
    })
}
// 船公司放箱-空箱申请列表查看
export function getTkApply(params) {
    return fetch({
        method: 'get',
        url: `/shipapply/query_tk_apply`,
        params,
    })
}
// 船公司放箱-空箱申请操作
export function setTkAudit(data) {
    return fetch({
        method: 'post',
        url: `/shipapply/do_tk_audit`,
        data,
    })
}
// 临时客户列表
export function getTempClientList(params) {
    return fetch({
        method: 'get',
        url: `/shipapply/query_temp_client`,
        params,
    })
}
// 临时用户新增
export function addTempClient(data) {
    return fetch({
        method: 'post',
        url: `/shipapply/add_temp_client`,
        data
    })
}
// 临时用户新增
export function modifyTempClient(data) {
    return fetch({
        method: 'post',
        url: `/shipapply/modify_temp_client`,
        data
    })
}
// 用户管理
export function getUserManage(params) {
    return fetch({
        method: 'get',
        url: `/shiptruckuser/query_tk_user`,
        params
    })
}
// id查询用户
export function getByIdUser(params) {
    return fetch({
        method: 'get',
        url: `/shiptruckuser/query_tk_user_by_id`,
        params
    })
}
// 用户管理
export function userManage(data) {
    return fetch({
        method: 'post',
        url: `/shiptruckuser/user_manage`,
        data
    })
}
// 用户管理
export function getRoleManage(params) {
    return fetch({
        method: 'get',
        url: `/shiptruckuser/query_tk_role`,
        params
    })
}
// 角色管理
export function roleManage(data) {
    return fetch({
        method: 'post',
        url: `/shiptruckuser/role_manage`,
        data
    })
}
// 角色权限列表
export function getRoleRightList(params) {
    return fetch({
        method: 'get',
        url: `/shiptruckuser/role_right_list`,
        params,
    })
}
// 保存角色权限
export function saveRoleRight(data) {
    return fetch({
        method: 'post',
        url: `/shiptruckuser /save_role_right`,
        data,
    })
}
// 修改放箱明细
export function modifyApplyDetail(data) {
    return fetch({
        method: 'post',
        url: `/shipapply/modify_applydetail`,
        data
    })
}
// 取消放箱
export function cancelByship(data) {
    return fetch({
        method: 'post',
        url: `/shipapply/cancel_byship`,
        data
    })
}
// 强制作废
export function forceCancelByship(applyDetailId) {
    return fetch({
        method: 'post',
        url: `/shipapply/force_cancel_byship/${applyDetailId}`,
    })
}
// 取消放箱
export function modifyTaskwayByship(data) {
    return fetch({
        method: 'post',
        url: `/shipapply/modify_taskway_byship`,
        data
    })
}
// 司机直接预约批量操作
export function setDriverDirectOrder(driverId,ifDirectOrder) {
    return fetch({
        method: 'post',
        url: `/driver/set_driver_direct_order/${driverId}/${ifDirectOrder}`
    })
}
// 拖车公司-处理放箱明细(1: 提交任务； 2：撤回任务；3：分配；4: 取消分配；5：修改作业司机, 6: 接收任务, 7: 拒绝任务, 8: 转移任务)
export function doApplyDetail(data) {
    return fetch({
        method: 'post',
        url: `/truck/do_apply_detail`,
        data
    })
}
// 退款申请明细查看
export function getBackFeeDetailt(params) {
    return fetch({
        method: 'get',
        url: `/querytruckfee/query_back_fee_detail`,
        params,
    })
}
// 查询船公司费用明细
export function getSipFeeDetail(params) {
    return fetch({
        method: 'get',
        url: `/queryshipfee/query_fee_detail`,
        params,
    })
}
// 船公司放箱-查询进场重箱残损列表
export function getInportDamageContainer(params) {
    return fetch({
        method: 'get',
        url: `/shipapply/query_inport_damage_container`,
        params,
    })
}
// 进场残损确认(通过  不通过)
export function sureInportDamageContainer(data) {
    return fetch({
        method: 'post',
        url: `/shipapply/sure_inport_damage_container`,
        data
    })
}
// 船公司-费用模版管理(1：新增；2：修改；3：删除)
export function feeModuleManage(data) {
    return fetch({
        method: 'post',
        url: `/shipapply/fee_module_manage`,
        data
    })
}
// 船公司-费用模版列表
export function getModuleList(data) {
    return fetch({
        method: 'get',
        url: `/shipapply/fee_module_list`,
        data
    })
}
// 船公司-费用模版列表
export function getCostList() {
    return fetch({
        method: 'get',
        url: `/shipapply/getCostList`
    })
}
// 拖车公司首页-作业统计（重 空  外进统计）
export function getTaskStatistics() {
    return fetch({
        method: 'get',
        url: `/truckfirstpage/task_statistics`
    })
}
// 拖车公司首页-车辆统计
export function getTruckStatistics() {
    return fetch({
        method: 'get',
        url: `/truckfirstpage/truck_statistics`
    })
}

// 拖车公司首页-司机统计
export function getDriverStatistics() {
    return fetch({
        method: 'get',
        url: `/truckfirstpage/driver_statistics`
    })
}
// 拖车公司首页-拖车司机作业量排名
export function getDriverTaskStatistics(params) {
    return fetch({
        method: 'get',
        url: `/truckfirstpage/driver_task_statistics`,
        params,
    })
}
// 拖车司机首页-车辆违规排名
export function getViolationStatistics(params) {
    return fetch({
        method: 'get',
        url: `/truckfirstpage/truck_violation_statistics`,
        params,
    })
}
// 拖车司机首页-费用统计(费目)
export function getByfeetypeStatistics(params) {
    return fetch({
        method: 'get',
        url: `/querytruckfee/fee_statistics_byfeetype`,
        params,
    })
}
// 拖车公司首页-拖车信用积分排名
export function getIntegralStatistics() {
    return fetch({
        method: 'get',
        url: `/truckfirstpage/truck_integral_statistics`
    })
}
// 拖车公司-集卡司机列表fenye
export function getTruckDriver(params) {
    return fetch({
        method: 'get',
        url: `/truck/driver/query_driver`,
        params,
    })
}
// 拖车公司-集卡司机列表
export function getAllTruckDriver(params) {
    return fetch({
        method: 'get',
        url: `/truck/driver/query_all_driver`,
        params,
    })
}
// 拖车公司-集卡司机操作
export function setTruckDriver(data) {
    return fetch({
        method: 'post',
        url: `/truck/driver/driver_manage`,
        data,
    })
}
// 拖车公司-充值押金  内网：172.0.10.86:8289 外网：222.178.229.146:8289
export function setAddMoney(data) {
    return fetch({
        method: 'post',
        url: `/gatherpay/make_order`,
        data,
    })
}
// 拖车公司-查询支付账单列表
export function getPayList(params) {
    return fetch({
        method: 'get',
        url: `/querytruckfee/query_pay_list`,
        params,
    })
}
// 拖车公司-查询支付账单明细列表
export function getPayDetail(params) {
    return fetch({
        method: 'get',
        url: `/querytruckfee/query_pay_detail`,
        params,
    })
}
// 拖车公司-查询待支付列表
export function getUnpayList(params) {
    return fetch({
        method: 'get',
        url: `/truckfee/query_unpay_list`,
        params,
    })
}
// 拖车公司-查询退款列表
export function getBackFeeList(params) {
    return fetch({
        method: 'get',
        url: `/querytruckfee/query_back_fee_list`,
        params,
    })
}
// 拖车公司-查询指定退款单明细
export function getBackFeeDetail(params) {
    return fetch({
        method: 'get',
        url: `/querytruckfee/query_back_fee_detail`,
        params,
    })
}
// 拖车公司-查询退款通知列表
export function getBackNoticeList(params) {
    return fetch({
        method: 'get',
        url: `/querytruckfee/query_back_notice_list`,
        params,
    })
}
// 拖车公司-查询退款通知箱明细
export function getBackNoticeDetail(params) {
    return fetch({
        method: 'get',
        url: `/querytruckfee/query_back_notice_detail`,
        params,
    })
}
// 拖车公司-预付款流水查看
export function getAdvancepayList(params) {
    return fetch({
        method: 'get',
        url: `/querytruckfee/query_advancepay_list`,
        params,
    })
}
// 拖车公司-扣款流水箱明细查看
export function getAdvancepayDetail(params) {
    return fetch({
        method: 'get',
        url: `/querytruckfee/query_advancepay_detail`,
        params,
    })
}
// 拖车公司-集卡车辆列表
export function getQueryTruck(params) {
    return fetch({
        method: 'get',
        url: `/truckinfo/query_truck`,
        params,
    })
}
// 拖车公司-集卡车辆管理(1：启用；2：禁用)
export function setTruckManage(data) {
    return fetch({
        method: 'post',
        url: `/truckinfo/truck_manage`,
        data,
    })
}
// 拖车公司-集卡注册申请列表查看
export function getTruckApply(params) {
    return fetch({
        method: 'get',
        url: `/truckinfo/query_truck_apply`,
        params,
    })
}
// 拖车公司-集卡注册申请明细查看
export function getTruckDetail(params) {
    return fetch({
        method: 'get',
        url: `/truckinfo/truck_apply_detail`,
        params,
    })
}
// 拖车公司-查询用户集卡车队  法人等信息
export function getByUserId() {
    return fetch({
        method: 'get',
        url: `/truckinfo/query_motorcade_byUserId`
    })
}
// 拖车公司-集卡注册申请管理（1：新增；2：修改；3：删除）
export function setTruckApply(data) {
    return fetch({
        method: 'post',
        url: `/truckinfo/truck_apply`,
        data,
    })
}
// 拖车公司-临时集卡挂靠列表查看
export function getTempTruck(params) {
    return fetch({
        method: 'get',
        url: `/truckinfo/query_temp_truck`,
        params,
    })
}
// 拖车公司-临时集卡挂靠审核
export function setTempTruck(data) {
    return fetch({
        method: 'post',
        url: `/truckinfo/do_temp_truck`,
        data,
    })
}

// 拖车公司-查询指定状态放箱列表
export function getTruckApplyDetail(params) {
    return fetch({
        method: 'get',
        url: `/truck/query_applydetail`,
        params,
    })
}

// 拖车公司-查询指定状态放箱列表
export function getShipDetail(params) {
    return fetch({
        method: 'get',
        url: `/portquery/ship/detail`,
        params,
    })
}
// 拖车公司-拖车司机违规记录查看
export function getViolationrecord(params) {
    return fetch({
        method: 'get',
        url: `/truck/query_truck_violationrecord`,
        params,
    })
}

// 拖车公司-查询作业中未作业车辆列表
export function getTruckByTaststatusList(params) {
    return fetch({
        method: 'get',
        url: `/truck/query_truckbytaskstatus`,
        params,
    })
}
// 拖车公司-查询作业中未作业司机列表
export function getDriverByTaststatusList(params) {
    return fetch({
        method: 'get',
        url: `/truck/query_driverbytaskstatus`,
        params,
    })
}
// 货站公司-查询作业统计
export function getCfsStatistics() {
    return fetch({
        method: 'get',
        url: `/cfsfirstpage/task_statistics`,
    })
}
// 货站公司-数据统计
export function getCfsDataStatistics(statisticsType) {
    return fetch({
        method: 'get',
        url: `/cfsfirstpage/data_statistics/${statisticsType}`,
    })
}
// 货站公司-查询指定状态的作业明细列表
export function getCfsTaskList(params) {
    return fetch({
        method: 'get',
        url: `/cfs/query_task_list`,
        params
    })
}
// 货站公司-任务处理
export function setCfsDoRecord(data) {
    return fetch({
        method: 'post',
        url: `/cfs/do_record`,
        data
    })
}

// 货站公司-根据ID查询任务及明细
export function getCfsRecord(params) {
    return fetch({
        method: 'get',
        url: `/cfs/get_record`,
        params
    })
}
/**
 * 单文件上传
 * params:{file:文件}
 */

export function uploadFileSingle(data) {
    return fetch({
        method: 'post',
        url: `/attachments/uploadSigle`,
        data,
    })
}
export function importJcApply(attachmentId) {
    return fetch({
        method: 'post',
        url: `/shipapply/import_jcapply/${attachmentId}`
    })
}

// 货站公司-待确认费用列表
export function getUnsureFeList(params) {
    return fetch({
        method: 'get',
        url: `/ship/query_unsurefee_list`,
        params
    })
}
// 船公司-查询待对账费用
export function getUnverifyfeeList(params) {
    return fetch({
        method: 'get',
        url: `/queryshipfee/query_unverifyfee`,
        params
    })
}
// 船公司-查询待对账费用
export function setUnverifyfee(data) {
    return fetch({
        method: 'post',
        url: `/ship/verifyfee`,
        data
    })
}
// 船公司-查询待对账费用
export function getAccountInfo(params) {
    return fetch({
        method: 'get',
        url: `/querytruckfee/query_account_info`,
        params
    })
}


// 船公司-查询待对账费用 新增2024
export function getAccountInfoList(params) {
    return fetch({
        method: 'get',
        url: `/querytruckfee/query_account_info_list`,
        params
    })
}

// 支付
export function setDrivePay(data) {
    return fetch({
        method: 'post',
        url: `/gatherpay/driver_pay`,
        data
    })
}
// 船公司-查询待对账费用
export function getPreSettle(data) {
    return fetch({
        method: 'post',
        url: `/shipapply/query_pre_settle`,
        data
    })
}
// admin-查询计划详情
// export function getApplydetailByAdmin(orderCode,taskCompanyId) {
//     return fetch({
//         method: 'get',
//         url: `/background/query_applydetail_byordercode/${orderCode}/${taskCompanyId}`
//     })
// }
// 船公司（拖车公司）-查询计划详情
export function getApplydetailByapplyid(orderCode,params) {
    return fetch({
        method: 'get',
        url: `/truck/query_applydetail_byordercode/${orderCode}`,
        params
    })
}
// 船公司（拖车公司）-分配轨迹
export function getDispatchHis(applyDetailId) {
    return fetch({
        method: 'get',
        url: `/truck/get_dispatch_his/${applyDetailId}`
    })
}

// 船公司（拖车公司）-作业状态
export function getTaskHis(applyDetailId) {
    return fetch({
        method: 'get',
        url: `/truck/get_task_his/${applyDetailId}`
    })
}

// 费用名称
export function getCostNameList(params) {
    return fetch({
        method: 'get',
        url: `/shipapply/getCostList`,
        params
    })
}

// 业务监控平台（船公司）
export function getPortqueryShip(params) {
    return fetch({
        method: 'get',
        url: `/portquery/ship`,
        params
    })
}
// 业务监控平台（船公司）
export function getPortqueryShipDetail(params) {
    return fetch({
        method: 'get',
        url: `/portquery/ship/detail`,
        params
    })
}
// 业务监控平台(拖车)
export function getPortqueryTruck(params) {
    return fetch({
        method: 'get',
        url: `/portquery/truck`,
        params
    })
}

// 业务监控平台（船公司）
export function getPortqueryTruckDetail(params) {
    return fetch({
        method: 'get',
        url: `/portquery/truck/detail`,
        params
    })
}
// 123.查看电子提单
export function getBillNumberPdf(applyId) {
    return fetch({
        method: 'get',
        url: `/shipapply/get_billnumber_pdf/${applyId}`
    })
}
//装箱单pdf
export function getEnchaseplanPdf(orderRecordId,detailId) {
    return fetch({
        method: 'get',
        url: `/gate/get_enchase_plan/${orderRecordId}/${detailId}`
    })
}

//装箱单pdf
export function get_area(pid) {
    return fetch({
        method: 'get',
        url: `/shipapply/get_area/${pid}`
    })
}
// 123.业务轨迹
// export function getQuerytaskinfo(params) {
//     return fetch({
//         method: 'get',
//         url: `/portquery/querytaskinfo`,
//         params
//     })
// }
// 业务轨迹新
export function getQuerytaskinfo(applyDetailId) {
    return fetch({
        method: 'get',
        url: `/background/get_work_history/${applyDetailId}`
    })
}
// 获取电子提单模板
export function getBillNumberModel(params) {
    return fetch({
        method: 'get',
        url: `/shipapply/get_billnumber_model`,
        params
    })
}
// 新增电子提单模板
export function doBillNumberModel(data) {
    return fetch({
        method: 'post',
        url: `/shipapply/do_billnumber_model`,
        data
    })
}
// 查询设备交接单
export function getEquimentReceipt(orderRecordId,detailId) {
    return fetch({
        method: 'get',
        url: `/gate/get_equiment_receipt/${orderRecordId}/${detailId}`
    })
}
// 查询支付状态
export function getPayResult(params) {
    return fetch({
        method: 'get',
        url: `/gatherpay/driver_pay_result`,
        params
    })
}
// 新增电子提单模板
export function submitTosPlan(applyId) {
    return fetch({
        method: 'post',
        url: `/ship_excel/submit_tos_plan/${applyId}`
    })
}
// 转移任务时, 获取联系人,联系电话
export function moveGetConcat() {
    return fetch({
        method: 'get',
        url: `/truck/move_get_concat`
    })
}
// 修改身份证
export function modifyIdcard(data) {
    return fetch({
        method: 'post',
        url: `/truck/modify_idcard`,
        data
    })
}
// 费用
export function queryAllFeeByCond(params) {
    return fetch({
        method: 'get',
        url: `/queryallfee/query_all_fee_by_cond`,
        params
    })
}
// 费用合计
export function querytaotalFeeByCond(params) {
    return fetch({
        method: 'get',
        url: `/queryallfee/query_taotalfee_by_cond`,
        params
    })
}
// 费用
export function queryAllYearFeeByCond(params) {
    return fetch({
        method: 'get',
        url: `/queryallfee/query_all_year_fee_sort`,
        params
    })
}
// 导出
export function feedetaildxcel(params) {
    return fetch({
        method: 'get',
        url: `/queryallfee/feedetaildxcel`,
        params
    })
}
// 导出
export function truckEncode(data) {
    return fetch({
        method: 'post',
        url: `/truck/encode`,
        data
    })
}
// 船公司放箱-查看作业方式操作记录
export function getTaskWayRecord(applyDetailId) {
    return fetch({
        method: 'get',
        url: `/shipapply/query_taskWayRecord/${applyDetailId}`
    })
}
// 二维码编号查询临时客户任务处理
export function getFindByCodeNumber(id) {
    return fetch({
        method: 'get',
        url: `/temporary/findByCodeNumber/${id}`
    })
}
// 拖车公司接收临时客户的任务
export function setTruckAcceptTask(data) {
    return fetch({
        method: 'post',
        url: `/temporary/truckAcceptTask`,
        data
    })
}
// 超重小票打印
export function getOverWeightPrint(applyDetailId,printType) {
    return fetch({
        method: 'get',
        url: `/shipapply/get_overweight_print/${applyDetailId}/${printType}`
    })
}
// 无纸化查验, 熏蒸转发TOS请求
export function postTosSpecial(data) {
    return fetch({
        method: 'post',
        url: `/shipapply/post_tos_special`,
        data
    })
}
// 火车箱-创建到达预报
export function createForcast(data) {
    return fetch({
        method: 'post',
        url: `/forecast/create`,
        data
    })
}
// 火车箱-导入到达预报
export function importForcast(attachmentId) {
    return fetch({
        method: 'post',
        url: `/forecast/import/${attachmentId}`
    })
}
// 161.火车箱-到达预报-落空
export function invalidForcast(forecastId) {
    return fetch({
        method: 'post',
        url: `/forecast/invalid/${forecastId}`
    })
}
// 161.火车箱-162.到达预报-查询
export function getforcast(params) {
    return fetch({
        method: 'get',
        url: `/forecast/getforcast`,
        params
    })
}
// 提单数据查询
export function getBillnumberData(params) {
    return fetch({
        method: 'get',
        url: `/background/get_billnumber_data`,
        params
    })
}
// 电子设备交接单查询
export function getEqData(params) {
    return fetch({
        method: 'get',
        url: `/background/get_eq_data`,
        params
    })
}
// 查询预约列表
export function getBackgroundOrder(params) {
    return fetch({
        method: 'get',
        url: `/background/get_backgroundorder`,
        params
    })
}

// 获取预约详情
export function getOrderDetail(orderRecordId) {
    return fetch({
        method: 'get',
        url: `/background/get_order_detail/${orderRecordId}`
    })
}
// 取消出闸
export function getCancelOutgate(orderRecordId) {
    return fetch({
        method: 'post',
        url: `/gate/bg_cancel_outgate/${orderRecordId}`
    })
}
// 取消进闸
export function getCancelIngate(orderRecordId) {
    return fetch({
        method: 'post',
        url: `/gate/bg_cancel_ingate/${orderRecordId}`
    })
}
// 取消预约明细
export function cancelOrderDetail(applyDetailId) {
    return fetch({
        method: 'post',
        url: `/background/cancel_order_detail/${applyDetailId}`
    })
}
// 2.查询密码验证
export function parametersCode(params) {
    return fetch({
        method: 'get',
        url: `/parameters/code`,
        params
    })
}

// 3.接口_更改换箱方式
export function changeCarryType(data) {
    return fetch({
        method: 'post',
        url: `/truck/change_carry_type`,
        data
    })
}

//修改是否经过智能闸口标识
export function updateIfPassAiGate(applyId,ifPassAiGate) {
    return fetch({
        method: 'post',
        url: `/shipapply/updateIfPassAiGate/${applyId}/${ifPassAiGate}`
    })
}

//合同到期时间
export function getLetterContractInfo(params){
    return fetch({
        method: 'get',
        url: `/letter/contractInfo`,
        params
    })    
}


//特殊需求申报 excel 获取 模板导入返回
export function importSpecialBox(attachmentId) {
    return fetch({
        method: 'post',
        url: `/special_report/import_special_box/${attachmentId}`
    })
}

//特殊需求申报 新增提交
export function specialReportSubmit(data) {
    return fetch({
        method: 'post',
        url: `/special_report/save`,
        data
    })
}

//

// 特殊需求申报 查询
export function getQueryReportList(params) {
    return fetch({
        method: 'get',
        url: `/special_report/queryReportList`,
        params
    })
}

//
// 特殊需求申报 作废
export function deleteSpecialReport(data) {
    return fetch({
        method: 'post',
        url: `/special_report/cancel`,
        data
    })
}

//特殊需求申报 详情
export function getQueryReportDetailList(params){
    return fetch({
        method: 'get',
        url: `/special_report/queryReportDetailList`,
        params
    })    
}




// WEBPACK FOOTER //
// ./src/api/outCard/card.js